<template>
    <svg class="progress-ring" viewBox="-51,-51,105,105">
        <circle class="progress-ring-circle" r="46"/>
        <path class="progress-ring-ring" :d="path" :style="{ stroke: ringColor }"/>
        <circle class="progress-ring-end" :cx="endX" :cy="endY" r="5" :style="{ fill: ringEndColor }"/>
        <text class="progress-ring-text" alignment-baseline="middle" text-anchor="middle">{{ text }}%</text>
    </svg>
</template>

<script>
export default {
    name: "ProgressRing",
    props: {
        value: {
            type: Number,
            default: 0,
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 100,
        },
        text: {
            type: null,
            default: '',
        },
        ringColor: {
            default: '#050566'
        },
        ringEndColor: {
            default: '#cecece00'
        },
    },
    computed: {
        theta() {
            const frac = (this.value - this.min) / (this.max + 1 - this.min) || 0;
            return frac * 2 * Math.PI;
        },
        path() {
            const large = this.theta > Math.PI;
            return `M0,-46 A46,46,0,${large ? 1 : 0},1,${this.endX},${this.endY}`;
        },
        endX() {
            return Math.cos(this.theta - Math.PI * 0.5) * 46;
        },
        endY() {
            return Math.sin(this.theta - Math.PI * 0.5) * 46;
        },
    },
}
</script>

<style scoped>
.progress-ring {
    position: absolute;
    left: 0%;
    top: 0%;
    right: 0%;
    bottom: 0%;
    z-index: 2;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    height: 100%;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
}

.progress-ring-circle {
    stroke: rgba(0, 0, 0, 0.1);
    stroke-width: 10;
    fill: none;
}

.progress-ring-ring {
    stroke-width: 10;
    fill: none;
}

.progress-ring-text {
    font-size: 2rem;
    font-weight: bold;
}
</style>
